/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * Maps the sticky journey track's position in the viewport to 0–1 progress.
 * While the inner canvas is `position: sticky`, the tall track keeps scrolling.
 */

import { useEffect, useState, type RefObject } from 'react';
import { chapterIndexForProgress } from '@/lib/aboutJourney';
import { readSiteHeaderHeight } from '@/lib/siteHeader';

export function useAboutJourneyProgress(trackRef: RefObject<HTMLElement | null>) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;

    const update = () => {
      const header = readSiteHeaderHeight();
      const view = window.innerHeight - header;
      const max = el.offsetHeight - view;
      const scrolled = header - el.getBoundingClientRect().top;
      const next = max <= 0 ? 0 : Math.min(1, Math.max(0, scrolled / max));
      setProgress(next);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [trackRef]);

  return { progress, activeIndex: chapterIndexForProgress(progress) };
}
